export default __webpack_public_path__ + "static/media/podcast.79a0676c.jpg";